import type { StateModel } from '../app/types/address.type.ts';
import baseApi from './meeting-md-api-slice';

const stateTypeApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchStates: builder.query<StateModel[], void>({
      query() {
        return `/state`;
      },
    }),
  }),
});

export const { useFetchStatesQuery } = stateTypeApi;
